import { useEffect } from "react";

import { useAppRemount } from "../appV2/context/AppRemountContext";
import { CbhFeatureFlag } from "../appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../appV2/FeatureFlags/useCbhFlag";
import { logEvent } from "../appV2/lib/analytics";
import { APP_V2_APP_EVENTS } from "../appV2/lib/analytics/events";
import { type AppListenerHandle, addAppResumeListener } from "../appV2/NativeAdapters/app.adapter";

// force the entire React tree to unmount and remount
export function useForceAppResetOnResume() {
  const isRemountingOnResumeEnabled = useCbhFlag(
    CbhFeatureFlag.GROWTH_WORKER_APP_DEBUGGING_REMOUNT_APP,
    {
      defaultValue: false,
    }
  );

  const { triggerRemount } = useAppRemount();

  useEffect(() => {
    if (!isRemountingOnResumeEnabled) {
      return;
    }

    let listenerHandle: AppListenerHandle | undefined;

    async function setupListener() {
      listenerHandle = await addAppResumeListener(() => {
        logEvent(APP_V2_APP_EVENTS.FORCE_APP_RESET_ON_RESUME);
        triggerRemount();
      });
    }

    void setupListener();

    return () => {
      void listenerHandle?.remove();
    };
  }, [isRemountingOnResumeEnabled, triggerRemount]);
}
